import React, {useEffect, useState} from 'react';
import {Button, Col, FormControl, Image, Modal, Row} from 'react-bootstrap';
import Loader from '../Loader';

const common_resize_dimensions = {
    "Instagram Post": {
        "height": 1080,
        "width": 1080,
        'dimension_units': "px"
    },
    "Instagram Story": {
        "height": 1920,
        "width": 1080,
        'dimension_units': "px"
    },
    "Facebook Post": {
        "height": 788,
        "width": 940,
        'dimension_units': "px"
    },
    // "Facebook Post": {
    //     "height": 1200,
    //     "width": 630,
    //     'dimension_units': "px"
    // },
    "Facebook Story": {
        "height": 1920,
        "width": 1080,
        'dimension_units': "px"
    },
    "Facebook Highlight": {
        "height": 1200,
        "width": 1800,
        'dimension_units': "px"
    },
    "Facebook Event": {
        "height": 500,
        "width": 262,
        'dimension_units': "px"
    },
    "Twitter Post": {
        "height": 512,
        "width": 1024,
        'dimension_units': "px"
    },
    "Youtube Thumbnail": {
        "height": 720,
        "width": 1280,
        'dimension_units': "px"
    },
    "Google Inline Rectangle": {
        "height": 250,
        "width": 300,
        'dimension_units': "px"
    },
    "Google Large Rectangle": {
        "height": 280,
        "width": 336,
        'dimension_units': "px"
    },
    "A4": {
        "height": 297,
        "width": 210,
        'dimension_units': "mm"
    }
};

const MagicResizeModal = ({show_magic_resize_modal, hide_magic_resize_modal, triggerSubscriptionWall}) => {
    const [photos, set_photos] = useState([]);
    const [computing, set_computing] = useState([false]);

    useEffect(() => {
        if(show_magic_resize_modal){
            generateResizedVersions();
        }
    }, [show_magic_resize_modal]);

    var generateResizedVersions = async () => {
        try{
            if(window.design_editor){
                var old_data = JSON.parse(JSON.stringify(window.design_editor.design.save()));
                var data = []
                set_computing(true);
                window.design_editor.undo_stack_disabled = true;
                var dummy_design = new window.DM_Design();
                dummy_design.load(window.design_editor.design.save());
                for(var key in common_resize_dimensions){
                    var asp = common_resize_dimensions[key].width/common_resize_dimensions[key].height;
                    if(asp>1){
                        dummy_design.base_width = 250;
                    }else{
                        dummy_design.base_height = 250;
                    }

                    dummy_design.magicResize(common_resize_dimensions[key].width,common_resize_dimensions[key].height,common_resize_dimensions[key].dimension_units)
                    dummy_design.pages[0].draw();
                    await dummy_design.wait_to_load();
                    dummy_design.pages[0].draw();
                    data.push({
                        src: dummy_design.pages[0].get_html(),
                        design_file: dummy_design.save(),
                        name_append: ' - ' + key,
                        title: key + ' (' + common_resize_dimensions[key].width+ ' x ' + common_resize_dimensions[key].height+ common_resize_dimensions[key].dimension_units+')'
                    })
                    delete dummy_design.base_width;
                    delete dummy_design.base_height;
                    dummy_design.load(old_data)
                }
                // dummy_design.handleWindowResize()
                // window.design_editor.draw();
                // window.design_editor.undo_stack_disabled = false;

                set_photos(data)
                set_computing(false);
            }
        }catch(err){
            console.log(err);
            set_computing(false);
        }
    }

    var resize_on_click = (photo_data) => {
        if (!triggerSubscriptionWall) {
            fetch(global.config.server_path+'saved_design/clone_saved_design/', {method: 'POST', headers: {'Content-Type':'application/json'}, 'credentials': 'include', body: JSON.stringify({saved_design_id: window.design_editor.design.design_save_id, design_file: photo_data.design_file,name_append: photo_data.name_append})})
                .then(resp => resp.json()).then(resp => resp.data)
                .then(data => {
                    window.open(global.config.website_url + 'designmaker/start/designs/' + data._id +'/edit', '_blank');
                })
        }
        else {
            hide_magic_resize_modal();
            triggerSubscriptionWall(true);
        }
    };

    var custom_dimensions_on_click = async () => {
        try{
            if(window.design_editor){
                // var old_data = window.design_editor.design.save();
                var custom_width = Number(document.getElementById('magicresize_custom_width').value);
                var custom_height = Number(document.getElementById('magicresize_custom_height').value);

                if(isNaN(custom_width) || custom_width ==0 || isNaN(custom_height) || custom_height ==0){
                    return
                }

                set_computing(true);
                var data = photos.concat([])

                var dummy_design = new window.DM_Design();
                dummy_design.load(window.design_editor.design.save());
                
                var asp = custom_width/custom_height;
                if(asp>1){
                    dummy_design.base_width = 250;
                }else{
                    dummy_design.base_height = 250;
                }
                dummy_design.magicResize(custom_width,custom_height,'px')
                dummy_design.pages[0].draw();
                await dummy_design.wait_to_load();
                dummy_design.pages[0].draw();
                data.push({
                    src: dummy_design.pages[0].get_html(),
                    design_file: dummy_design.save(),
                    name_append: ' - ' + custom_width + ' x ' + custom_height + ' px',
                    title: 'Custom Dimensions' + ' (' + custom_width+ ' x ' + custom_height+ 'px)'
                })
                // delete window.design_editor.design.base_width;
                // delete window.design_editor.design.base_height;
                // window.design_editor.design.load(old_data)
                // window.design_editor.design.handleWindowResize();
                // window.design_editor.draw();
                // window.design_editor.needs_redraw = true;
                set_photos(data)
                set_computing(false);
            }
        }catch(err){
            console.log(err);
            set_computing(false);
        }
    }

    var toggle_overlay = () => {
        if (window.document.getElementById('popover_overlay').style.display == "none") {
            window.document.getElementById('popover_overlay').style.display = "block"
        } else {
            window.document.getElementById('popover_overlay').style.display = "none"
        }
    }

    const CustomDimensionBox = () => (
        <div style={{ display : 'inline-flex', 'float': 'right', 'fontWeight': 'normal', 'fontSize': 14, 'paddingRight' : 20}}>
            <span style={{padding : 5, margin : 'auto'}}>Custom</span>
            <FormControl
                style={{height: 30, 'width': 70}}
                type="text"
                id="magicresize_custom_width"
                placeholder="width"
            />
            <span style={{padding : 5, margin : 'auto'}}> x </span>    
            <FormControl
                style={{height: 30, 'width': 70}}
                type="text"
                id="magicresize_custom_height"
                placeholder="height"
            />
            <span style={{padding : 5, margin : 'auto'}}> px </span>    
            <Button onClick={custom_dimensions_on_click} type="button" style={{backgroundImage : 'none', backgroundColor: '#f1f2f3', height: 30, width: 60, padding: 0}}>Apply</Button>
        </div>
    );


	return (
		<Modal show={show_magic_resize_modal} onHide={hide_magic_resize_modal} bsSize="large">
            <Modal.Header closeButton>
                <Modal.Title style={{fontFamily: 'Montserrat', fontWeight: 'bold'}}>Magic Resize <CustomDimensionBox/></Modal.Title>
            </Modal.Header>
            <Modal.Body style={{minHeight: 300, padding: 0}}>
            	<Row style={{padding: 15}}>
	            	{photos.map(photo_data => (
	            		<Col xs={4} style={{textAlign: 'center'}}>
	            			<div dangerouslySetInnerHTML={{__html: photo_data.src}} onClick={() => resize_on_click(photo_data)} style={{cursor: 'pointer',height: 250, width: 250, margin: 'auto', backgroundColor: '#f1f2f3', marginTop: 10, verticalAlign: 'middle', display: 'inline-flex'}}>
	            				{/* <Image style={{maxHeight: 250, margin: 'auto', display: 'block', verticalAlign: 'middle', maxWidth: '100%', objectFit: 'contain'}} src={photo_data.src} /> */}
	            			</div>
                            <p>{photo_data.title}</p>
	            		</Col>
	            	))}
            	</Row>
                <div  style={{ width:'100%', height:'100%', position:'absolute', minHeight: 300}}>
                    <Loader show_loader={computing} style={{}} />
                </div>
            </Modal.Body>
            <Modal.Footer>
                <div/>
            </Modal.Footer>
        </Modal>
	);
}

export default MagicResizeModal;